import React, { useState } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import styled from "styled-components";

import TruncateText from "core/TruncateText";

import { TagWrapper, TagContainer, ProcessingSpinnerIcon } from "./styles";

import { getBrandObject } from "./helpers";

import RemovableTagComponent from "./RemovableTagComponent";

const UnstyledTag = ({
    brandType = "primary",
    className,
    text,
    path,
    onClick,
    isStrikethrough = false,
    isDisabled = false,
    ariaLabel = "",
    isTruncated = false,
    isLoading = false,
    disableRemoveFromUI = false
}) => {
    const [isVisible, updateVisible] = useState(true);

    if (!text) {
        return null;
    }

    const isLink = !!path;
    const isRemoveable = !isLink;

    const brandObj = getBrandObject({
        brandType,
        type: isRemoveable ? "removeable" : "default"
    });

    const lowercaseText = text.toLowerCase();

    const isTextString = typeof text === "string";

    const tagHelperText = isTextString ? lowercaseText : ariaLabel;

    const tagVisualText = isTruncated ? (
        <TruncateText charLimit={50}>{lowercaseText}</TruncateText>
    ) : (
        lowercaseText
    );

    const conditionalProps = isLink && {
        as: Link,
        to: path,
        title: `See other tag results for "${tagHelperText}" tag`
    };

    return isVisible ? (
        <TagWrapper className={className}>
            <TagContainer
                {...{
                    ...conditionalProps,
                    isStrikethrough,
                    isDisabled,
                    isLink,
                    brandObj
                }}
            >
                <span>{isLoading ? "Processing" : tagVisualText}</span>

                {isRemoveable && !isLoading && (
                    <RemovableTagComponent
                        {...{
                            text,
                            isDisabled,
                            tagHelperText,
                            onClick,
                            disableRemoveFromUI,
                            updateVisible,
                            isLink
                        }}
                    />
                )}

                {isLoading && <ProcessingSpinnerIcon />}
            </TagContainer>
        </TagWrapper>
    ) : null;
};

const Tag = styled(UnstyledTag)``;

Tag.propTypes = {
    brandType: PropTypes.oneOf(["primary", "secondary"]),
    text: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
    path: PropTypes.string,
    onClick: PropTypes.func,
    isStrikethrough: PropTypes.bool,
    isDisabled: PropTypes.bool,
    ariaLabel: PropTypes.string,
    isTruncated: PropTypes.bool,
    isLoading: PropTypes.bool,
    disableRemoveFromUI: PropTypes.bool
};

export default Tag;
